import axios from 'axios';
import { message } from 'antd';
import { useGlobalStore } from '../stores/useGlobalStore';
import { notifyError } from '../utils/notify';
const service = axios.create({
    baseURL: '/api',
    timeout: 10 * 1000
});
// Handle Error
const handleError = (error) => {
    if (error.response?.status === 401 || error.response?.status === 504) {
        // 清理登录信息（按你项目实际情况）
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        // 跳转登录页
        window.location.href = '/login';
        return Promise.reject(error);
    }
    message.error(error.message || 'error');
    return Promise.reject(error);
};
service.interceptors.request.use((config) => {
    const token = useGlobalStore.getState().token;
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (!(config.data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json';
    }
    return config;
}, handleError);
service.interceptors.response.use((response) => {
    // 如果返回的是 Blob (文件下载)，直接返回整个 response 或 data
    if (response.config.responseType === 'blob') {
        return response.data;
    }
    const data = response.data;
    if (data.ret) {
        return data;
    }
    else {
        if (data.status === 1) {
            return data;
        }
        if (data.status === -2) {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('robing_hanflow_userInfo');
            window.location.href = '/login';
            return Promise.reject(data);
        }
        else {
            notifyError(data.message);
            return data;
        }
    }
}, handleError);
export { service };
